import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=d6baafe4&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6baafe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6baafe4')) {
      api.createRecord('d6baafe4', component.options)
    } else {
      api.reload('d6baafe4', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=d6baafe4&scoped=true&", function () {
      api.rerender('d6baafe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4nfp8MiWe6vGD/JS/comp/Accordion.vue"
export default component.exports